import { UserRole } from "@/hooks/useUserSettings";
import posthog, { PostHog } from "posthog-js";
import { ReactNode, createContext } from "react";

export const AnalyticsContext = createContext<PostHog>(posthog);

export const trackedRoles: UserRole[] = ["company_admin", "user"];

if (process.env.REACT_APP_POSTHOG_API_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_API_KEY || "", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
  });
}

export default function AnalyticsProvider({ children }: { children: ReactNode }) {
  return <AnalyticsContext.Provider value={posthog}>{children}</AnalyticsContext.Provider>;
}
